import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=2e4a7e97&scoped=true&"
import script from "./Credit.vue?vue&type=script&lang=js&"
export * from "./Credit.vue?vue&type=script&lang=js&"
import style0 from "./Credit.vue?vue&type=style&index=0&id=2e4a7e97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4a7e97",
  null
  
)

export default component.exports